<template>
  <div class="containter">
    <navTop class="navTop navFixed" :topFixed="true" :topIndex="topIndex" :childrenIndex="childrenIndex" />
    <banner :bannerObj="bannerObj" @dialogVisible="getChild" />
    <p class="payment-content">智绘收款平台定制化支付解决方案、助力中小企业、支付无忧</p>
    <product-content
      :productContentArr = product
    />
    <footer-a />
    <back-top />
    <dialog-business :dialogVisible="dialogVisible" @dialogVisible="closeFn"/>
  </div>
</template>

<script>
import navTop from '../components/nav'
import banner from '../components/banner'
import productContent from '../components/productContent'
import footerA from '../components/footer'
import backTop from '../components/backTop'
import dialogBusiness from '../components/dialogBusiness'
import i1 from '../assets/images/payment/1.png'
import i2 from '../assets/images/payment/2.png'
import i3 from '../assets/images/payment/3.png'
import i4 from '../assets/images/payment/4.png'
import i5 from '../assets/images/payment/5.png'
import i6 from '../assets/images/payment/6.png'
export default {
  data () {
    return {
      product: [
        {img: i1, boxStyle: '', content: '以支付连接全球，为客户创造价值，共同打造健康繁荣新零售生态圈', label: '互联、互助、互通', type: 'left', style: 'width: 1.77rem;padding-left: 0.48rem;'},
        {img: i2, boxStyle: '', content: '轻松接入、无忧管理，相同付出、更多收获', label: '快捷支付、协议支付', type: 'right', style: 'width: 1.77rem;padding-right:0.68rem;'},
        {img: i3, boxStyle: '', content: '支付场景覆盖、安全稳定、快速接入', label: '服务商合作通道邀你开启支付功能新时代', type: 'left', style: 'width: 1.77rem;padding-left: 0.48rem;'},
        {img: i4, boxStyle: 'width:2.6rem;', content: '简单易用的用户体验，零代码建立传输任务，降低用户使用门槛，与客户内部办公平台（如：OA，APP，邮件等) 进行无缝集成，作为客户内部报告制作与发布平台', label: '智绘收款平台定制化支付解决方案助力中小企业、支付无忧', type: 'right', style: 'width: 1.77rem;padding-right:0.68rem;'},
        {img: i5, boxStyle: '', content: '', label: '快速付款，操作简单，支付安全，全平台支持', type: 'left', style: 'width: 1.77rem;padding-left: 0.48rem;'}
      ],
      bannerObj: {
        img: i6,
        title: '聚合支付',
        content: '让支付变得简单、安全！',
        button: '业务咨询'
      },
      topIndex: 1,
      childrenIndex: 4,
      dialogVisible: false
    }
  },
  components: {
    navTop,
    banner,
    productContent,
    backTop,
    footerA,
    dialogBusiness
  },
  methods: {
    getChild (v) {
      this.dialogVisible = v
    },
    closeFn (v) {
      this.dialogVisible = v
    }
  }
}
</script>

<style scoped>
.payment-content{
  font-size:20px;
  font-family:PingFang SC;
  font-weight:500;
  line-height:35px;
  color:rgba(102,102,102,1);
  margin-bottom: 75px;
  margin-top: 0.57rem;
}

</style>



// WEBPACK FOOTER //
// src/view/payment.vue